import styled from 'styled-components';

import InfoButtonIcon from '~/icons/info-button.svg';
import CommonButton from '~atoms/CommonButton';

export const OptionsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: '20rem',
  flexWrap: 'wrap',
  paddingBottom: '25rem',
  marginLeft: '20rem',
  marginTop: '20rem',
  columnGap: '20rem',
});

export const OptionTitle = styled.div<{ color?: string }>(
  ({ theme, color }) => ({
    fontSize: theme.typography.size16,
    marginLeft: '20rem',
    color: color ?? theme.palette.dimGray,
    marginBottom: '10rem',
  })
);

export const OptionButton = styled(CommonButton)(({ theme }) => ({
  color: theme.palette.erieBlack,
  fontSize: theme.typography.size16,
  border: 'unset',
  boxShadow: `0 2rem 3rem ${theme.palette.superLightGray}`,
  '&[data-is-selected="true"]': {
    border: `2rem solid ${theme.palette.darkLiver}`,
  },
}));

export const InfoButton = styled(InfoButtonIcon)(() => ({
  verticalAlign: 'super',
  cursor: 'pointer',
}));
